import React, { useEffect, useRef, useState } from "react";

// Custom cursor: small dot follower + outer ring that grows on interactive elements.
// Hidden on touch devices; disabled below 900px width.
export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    if (isTouch || window.innerWidth < 900) return;
    setEnabled(true);
    document.documentElement.classList.add("has-custom-cursor");

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;
    let raf;

    const onMove = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${mx - 4}px, ${my - 4}px, 0)`;
      }
    };
    const step = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ringRef.current) ringRef.current.style.transform = `translate3d(${rx - 18}px, ${ry - 18}px, 0)`;
      raf = requestAnimationFrame(step);
    };

    const setGrow = (grow, mode = "link") => {
      if (!ringRef.current) return;
      ringRef.current.classList.toggle("is-grow", grow && mode === "link");
      ringRef.current.classList.toggle("is-text", grow && mode === "text");
    };
    const overHandler = (e) => {
      const t = e.target;
      if (!t || !(t instanceof Element)) return;
      if (t.closest("a, button, [role='button'], input, select, textarea, label, [data-cursor='link']")) {
        setGrow(true, "link");
      } else if (t.closest("h1, h2, h3, h4, .font-serif-display, [data-cursor='text']")) {
        setGrow(true, "text");
      } else {
        setGrow(false);
      }
    };
    const outHandler = () => setGrow(false);

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", overHandler);
    document.addEventListener("mouseleave", outHandler);
    raf = requestAnimationFrame(step);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", overHandler);
      document.removeEventListener("mouseleave", outHandler);
      document.documentElement.classList.remove("has-custom-cursor");
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div ref={ringRef} className="dk-cursor-ring" aria-hidden="true" />
      <div ref={dotRef} className="dk-cursor-dot" aria-hidden="true" />
    </>
  );
}
